import { FetchServiceAxios } from "@lib/helpers/fetchServiceAxios";
import type { StoreData } from "../controller";
import type {
    ParcelShopAddress,
    ParcelShopCoordinates,
} from "@lib/api-services/services/shipping-methods-service/types";

export const getParcelShopsByCoordinates = async ({
    latitude,
    longitude,
}: ParcelShopCoordinates): Promise<StoreData[]> => {
    return await FetchServiceAxios.get<StoreData[]>(
        "/api/checkout/parcel-shops/search/coordinates",
        {
            params: {
                latitude,
                longitude,
            },
        }
    );
};

export const getParcelShopsByAddress = async ({
    city,
    postCode,
}: ParcelShopAddress): Promise<StoreData[]> => {
    return await FetchServiceAxios.get<StoreData[]>("/api/checkout/parcel-shops/search/address", {
        params: {
            city,
            postCode,
        },
    });
};
